$ = require('jquery');
const { detect } = require('detect-browser');
global.browser = detect();

window.players = [];

var ismob;

$(function(){
  $('html').addClass(browser.name);

  ismob = window.innerWidth < 700;

  randomizeLinks();
  randomBackground();

  initVimeos();

  $('body').addClass('in');
  setTimeout(function(){
    $('body').removeClass('in');

    setTimeout(function(){
      $('body').addClass('in');

      setTimeout(function(){
        $('body').removeClass('in');

        setTimeout(function(){
          $('body').addClass('in');
        }, Math.random()*100 + 80);
      }, Math.random()*100 + 80);
    }, Math.random()*200 + 100);

  }, 400);

  $('a[href="#home"]').click(function(e){
    e.preventDefault();
    $('.act').removeClass('act');
    randomizeLinks();
  });

  $('a[href="#edit"]').click(function(e){
    e.preventDefault();
    randomizeLinks();
    randomBackground();
  });

  $('a.close').click(function(e){
    e.preventDefault();
    $('.act').removeClass('act');
    randomizeLinks();
  });

  $('.video--wrap--embed').click(function(){
    if(ismob){
      if($('.video.act').length>0){
        $('.video.act iframe').addClass('in');
        var vimeo = $('.video.act iframe').get(0).vimeoref;
        vimeo.getPaused().then(function(p){
          if(p){
            vimeo.play();
            $('.video.act').addClass('hide-info');
            $('.video.act iframe').addClass('in');
          } else {
            vimeo.pause();
            $('.video.act').removeClass('hide-info');
            $('.video.act iframe').removeClass('in');
          }
        });
      }
    }
  });

  $(document).on('keyup', function(e){
    // console.log(e.keyCode);
    if(e.keyCode==13 || e.keyCode==32){
      if($('.video.act').length>0){
        $('.video.act iframe').addClass('in');
        var vimeo = $('.video.act iframe').get(0).vimeoref;
        vimeo.getPaused().then(function(p){
          if(p){
            vimeo.play();
            $('.video.act').addClass('hide-info');
            $('.video.act iframe').addClass('in');
          } else {
            vimeo.pause();
            $('.video.act').removeClass('hide-info');
            $('.video.act iframe').removeClass('in');
          }
        });
      }
    }

    if(e.keyCode==27) {
      $('.video.act .video-close').click();
    }
    /*
    if(e.keyCode==32){
      for(var i=0; i<window.players.length;i++){
        window.players[i].pause();
      }
    }
    */
  });

  $('a.pop').click(function(e){
    e.preventDefault();

    if($('body').hasClass('video-on')){
      return;
    }

    if(!$(this).hasClass('act')){
      var id = $(this).attr('href').substr(1);
      $('.popup.act').removeClass('act');
      $('a.act').removeClass('act');
      $(this).addClass('act');
      $('.'+id).addClass('act');

      if(id=='about') {
        $('.floaty').not(this).each(function(idx){
          var left = 0;
          var top = window.innerHeight * 0.95;
          if(idx==0) left = window.innerWidth * 0.06;
          if(idx==1) left = window.innerWidth * 0.33;
          if(idx==2) left = window.innerWidth * 0.66;
          if(idx==3) left = window.innerWidth * 0.94;
          $(this).css({
            'left' : left,
            'top' : top,
          })
        });
      } else if(id=='help') {
        $('.floaty').not(this).each(function(idx){
          var left = window.innerWidth * 0.06;
          var top = 0;
          if(idx==0) top = window.innerHeight * 0.24;
          if(idx==1) top = window.innerHeight * 0.49;
          if(idx==2) top = window.innerHeight * 0.74;
          if(idx==3) top = window.innerHeight * 0.95;

          $(this).css({
            'left' : left,
            'top' : top,
          })
        });
      } else if(id=='file') {
        $('.floaty').not(this).each(function(idx){
          var left = window.innerWidth * 0.25;
          var top = window.innerHeight * 0.05;
          if(idx==0) left = window.innerWidth * 0.25;
          if(idx==1) left = window.innerWidth * 0.50;
          if(idx==2) left = window.innerWidth * 0.75;
          if(idx==3) left = window.innerWidth * 0.94;

          $(this).css({
            'left' : left,
            'top' : top,
          })
        });
      } else {
        $('.floaty').not(this).each(function(idx){
          var left = window.innerWidth * 0.94;
          var top = window.innerHeight * 0.05;
          if(idx==0) top = window.innerHeight * 0.06;
          if(idx==1) top = window.innerHeight * 0.33;
          if(idx==2) top = window.innerHeight * 0.66;
          if(idx==3) top = window.innerHeight * 0.95;

          $(this).css({
            'left' : left,
            'top' : top,
          })
        });
      }

      let thisLeft = $('.link.home').get(0).getBoundingClientRect().right + 10;
      let thisTop = window.innerHeight * 0.05;

      if(id=='help') {
        thisLeft = window.innerWidth * 0.53;
      }

      if(id=='file') {
        thisLeft = window.innerWidth * 0.03;
        thisTop = window.innerHeight * 0.55;

        if(window.innerWidth <= 700) {
          thisTop = window.innerHeight * 0.45;
        }
      }

      $(this).css({
        'left' : thisLeft,
        'top' : thisTop,
      });
    } else {
      $('.act').removeClass('act');
      randomizeLinks();
    }
  });

  $('.popup').scroll(function(){
    var top = $(this).scrollTop() + window.innerHeight*0.05;
    $(this).find('.close').css({
      'top' : top+'px',
    });
  });
});

function initVimeos(){
  $('.video--wrap--embed').each(function(){
    var id = $(this).attr('data-id');
    var opts = {
      id: id,
      muted: false,
      controls: false,
      autopause: false,
      autoplay: false,
      background: true,
      loop: false,
      playsinline: true,
      byline: false,
      portrait: false,
    };

    var player = new Vimeo.Player(this, opts);


    player.ready().then(function() {
      player.setVolume(1);
    });

    player.on('loaded', function() {
      window.players.push(player);
      player.parent = $(player.element).parents('.video');
      player.element.vimeoref = player;

      setTimeout(function(){
        $(player.parent).addClass('in');
      }, window.players.length * 300 + Math.random()*200);
    });
    /*
    player.on('play', function() {
      console.log('Played the video');
      var el = this.element;
      setTimeout(function(){
        $(el).addClass('in');
      }, 2900);
    });
    */

    player.getVideoTitle().then(function(title) {
      console.log('title:', title);
    });
  });

  $('.video').click(function(){
    if($(this).hasClass('act')) return;
    $('body').addClass('video-on');
    $('.act').removeClass('act');
    // randomizeLinks();
    $(this).addClass('act');

    var el = $(this).find('.video--wrap--info');

    setTimeout(function(){
      $('.video .video-guide').remove();
      $('.video-guide').clone().appendTo(el).slideToggle(500);
    }, 800);

    $('.video-close').clone().appendTo($(this)).show(400);

    $('.video-close').unbind('click').click(function(e){
      e.preventDefault();
      e.stopPropagation();
      $('body').removeClass('video-on');
      $('.act').removeClass('act');
      $('.video .video-guide').remove();
      $('.video .video-close').remove();
      randomizeLinks();

      $('.video').removeClass('hide-info');
      $('.video iframe').removeClass('in');


      for(var i=0; i<window.players.length;i++){
        window.players[i].pause();
      }
    });
  });
}

$(window).resize(function(){
  ismob = window.innerWidth < 700;

  if($('.popup.act').length==0){
    randomizeLinks();
  } else {
    randomizeVideos();
  }
});

function randomBackground(){
  var ran = Math.floor(Math.random()*4.99);
  var url = './img/bg-'+ran+'.jpg';
  $('.wrapper').css('background-image','url('+url+')');
}

function randomizeLinks(){
  $('.floaty').each(function(){
    var left = window.innerWidth*0.05 + (Math.random()*window.innerWidth*0.9);
    var top = window.innerHeight*0.05 + (Math.random()*window.innerHeight*0.9);
    $(this).css({
      'left' : left,
      'top' : top,
    }).addClass('trans');
  })

  randomizeVideos();
}

function randomizeVideos(){
  $('.video:not(.act)').each(function(){
    var h = window.innerWidth*.33*0.585;
    var left = window.innerWidth*0.05 + (Math.random()*window.innerWidth*0.66);
    var top = window.innerHeight*0.05 + (Math.random()*(window.innerHeight*0.9-h));
    $(this).css({
      'left' : left,
      'top' : top,
    });
  })
}
